import React from 'react';
import { HELP } from '../../data/content';
import SectionHeader from '../SectionHeader';
import { useIntersection } from '../../hooks/useIntersection';

export default function Help() {
  const { ref, visible } = useIntersection();
  return (
    <section id="help" style={{ padding: '72px 0', borderBottom: '1px solid #D1D5DB' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
        <SectionHeader num={HELP.sectionNum} title={HELP.title} titleEm={HELP.titleEm} body={HELP.body} />
        <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {HELP.items.map((item, i) => (
            <div key={i} style={{
              display: 'flex', gap: 16, alignItems: 'flex-start',
              padding: '18px 20px', background: 'var(--gray-lt)', borderRadius: 8,
            }}>
              <span style={{ fontSize: 20, minWidth: 26 }}>{item.icon}</span>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink)', marginBottom: 4 }}>{item.title}</div>
                <div style={{ fontSize: 13, color: 'var(--gray)', lineHeight: 1.65 }}>{item.body}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
